import ContactInfo from '@/types/ContactInfo';
import Util from './Util';

const ValidateUtil = {
    validateContactInfo(contactInfo: ContactInfo): string[] {
        const errors = new Array<string>();
        if (Util.isEmpty(contactInfo.email)) {
            errors.push('email');
        }
        if (Util.isEmpty(contactInfo.mobileNumber)) {
            errors.push('mobilnummer');
        }
        if (!contactInfo) {
            errors.push('kontaktinformation');
        }
        if (!contactInfo.address) {
            errors.push('address');
        }
        if (Util.isEmpty(contactInfo.address.recipientName)) {
            errors.push('namn');
        }
        if (Util.isEmpty(contactInfo.address.streetAddress)) {
            errors.push('gatuadress');
        }
        if (Util.isEmpty(contactInfo.address.postalCode)) {
            errors.push('postkod');
        }
        if (Util.isEmpty(contactInfo.address.city)) {
            errors.push('stad');
        }
        if (Util.isEmpty(contactInfo.address.countryCode)) {
            errors.push('land');
        }
        return errors;
    }
};

export default ValidateUtil;
